<template>
    <fragment>
        <tr>
            <td>{{ line.designation }}</td>
            <td>{{ line.company_designation}}</td>
            <td class="text-right">{{ currency(line.total_ht)  }}</td>
            <td class="text-right">{{ currency(line.total_ttc)  }}</td>
            <td class="text-right">{{ currency(line.total_remaining)  }}</td>
            <td class="text-right">
                <input type="number" class="form-control text-right" min="0" id="payment_amount" :name="'lines['+ line.class +']['+ line.id +'][payment_amount]'" step="0.01" v-model="line.amount" required>
            </td>
            <td class="text-right">
                <span class="btn btn-sm transparent" @click="emitEventLineDeleted">
                <i class="far fa-trash"></i>
            </span>
            </td>
        </tr>
    </fragment>
</template>

<script>

import Swal from "sweetalert2";

export default {
    name: 'payable-line',
    props: ['line', 'oldLine', 'index'],
    data(){
        return {
       
        }
    },
    methods: {
         emitEventLineDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('line-deleted', this.index)
                    }
                })
            },
    },
    mounted(){
        this.line.amount = this.line.total_remaining >= 0 ? this.line.total_remaining : this.line.total_remaining * -1;
    }
}
</script>